import { APP_BOOTSTRAP_LISTENER, NgModule } from '@angular/core';
import { GenThemeService } from '../../services/theme.service';

export function initGenTheme(themeService: GenThemeService) {
  return () => themeService.init();
}

@NgModule({
  providers: [
    {
      provide: APP_BOOTSTRAP_LISTENER,
      multi: true,
      useFactory: initGenTheme,
      deps: [GenThemeService],
    },
  ],
})
export class GenThemeModule {}
